export default __webpack_public_path__ + "static/media/detail_mobile_10_3.c033894f.jpg";